export default "__VITE_ASSET__b5392d51__"